import react from "react";

const Button = (props) => {
  let defProps = {
    label: "",
    size: "-size_L",
    isActive: false,
    ariaPressed: null,
  };
  let Props = { ...defProps, ...props };
  let ifActive = Props.isActive ? "-active" : "";
  let addClass = Props.addClass ? Props.addClass : "";
  let ariaPressed = Props.ariaPressed ? Props.ariaPressed : null;
  return (
    <button
      className={`${addClass} ${ifActive} ${Props.size}`}
      data-id={Props.id}
      key={Props.id}
      onClick={(item) => {
        Props.onClick(item.currentTarget.dataset.id);
      }}
      aria-pressed={ariaPressed}
    >
      {Props.label}
    </button>
  );
};

export default Button;
